const REQUIRES_DATA: string[] = [
  "highcharts",
  "timeseries",
  "sight",
  "seiches",
  "wind",
  "textcode",
  "radar",
  "image",
  "images",
  "line_graph",
  "link",
  "links",
  "textcode",
  "text",
  "report",
  "probabilities",
  "html",
  "image",
  "iframe",
  "opmet_report",
  "inline_pdf",
  "early_warning_table",
];

/**
 * Type guard: response body is an error payload with string `error` and `message`.
 * When true, the message should be presented as the widget body (same path as HTML body).
 */
export const isWidgetErrorResponse = (
  value: unknown,
): value is { error: string; message: string } =>
  typeof value === "object" &&
  value !== null &&
  "error" in value &&
  "message" in value &&
  typeof (value as { error: unknown }).error === "string" &&
  typeof (value as { message: unknown }).message === "string";

/*
    Function to help determine if a widget requires additional data to be fetched.
*/
export const requiresAdditionalDataToBeFetched = (renderer: string) => {
  return REQUIRES_DATA.includes(renderer);
};
